import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  clearPwaHighlightAfterLogin,
  dismissPwaBanner,
  isPwaHighlightAfterLogin,
  shouldShowPwaBanner,
} from '@/lib/pwa-install';

export function PwaInstallBanner() {
  const [visible, setVisible] = useState(() => shouldShowPwaBanner());
  if (!visible) return null;

  const isPostLogin = isPwaHighlightAfterLogin();

  const handleDismiss = () => {
    dismissPwaBanner();
    clearPwaHighlightAfterLogin();
    setVisible(false);
  };

  return (
    <div
      className={
        isPostLogin
          ? 'rounded-xl border border-primary/30 bg-primary/5 p-4 flex gap-3 items-start'
          : 'rounded-xl border bg-muted/40 p-4 flex gap-3 items-start'
      }
    >
      <div className="rounded-lg bg-primary/10 p-2 shrink-0">
        <Smartphone className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0 space-y-2">
        <p className="font-medium text-sm sm:text-base">
          {isPostLogin
            ? '¿Quieres instalar FOCO en tu celular?'
            : 'Accede más rápido instalando FOCO'}
        </p>
        <p className="text-xs sm:text-sm text-muted-foreground">
          Ábrela desde tu pantalla de inicio como una app. Te mostramos los pasos según tu teléfono (Android o
          iPhone).
        </p>
        <Button asChild size="sm" variant={isPostLogin ? 'default' : 'secondary'} className="h-9">
          <Link to="/install-app" onClick={clearPwaHighlightAfterLogin}>
            Ver guía de instalación
          </Link>
        </Button>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0 text-muted-foreground"
        onClick={handleDismiss}
        aria-label="Ocultar aviso de instalación"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
